import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getCurrencies } from "../../../common/services/markets/currencyService";
import SearchBox from "../../../common/components/search/searchBox";
import CurrenciesTable from "./currenciesTable";
import { withTranslation } from "react-i18next";

class Currencies extends Component {
  constructor(props) {
    super(props);

    this.handleCurrencyUpdated = this.handleCurrencyUpdated.bind(this);
  }

  state = {
    currencies: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
    paginationState: {
      currentPage: 0,
      pageSize: 20,
    },
  };

  async componentDidMount() {
    this.setState({ currencies: await getCurrencies(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      paginationState: {
        ...this.state.paginationState,
        currentPage: 0,
      },
    });
  };

  handleSort = (colId, sort) => {
    if (colId && sort) {
      this.setState({
        sortColumn: {
          path: colId,
          order: sort,
        },
      });
    }
  };

  handleToggleActiveOnly = () => {
    this.setState({
      activeOnly: !this.state.activeOnly,
      paginationState: {
        ...this.state.paginationState,
        currentPage: 0,
      },
    });
  };

  handleCurrencySelected = (currency, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(currency, this.handleCurrencyUpdated, isNew);
  };

  handleCurrencyUpdated = (currency) => {
    const currencies = [...this.state.currencies];
    const index = currencies.findIndex(
      (u) => u.currencyId === currency.currencyId
    );
    if (index > -1) {
      currencies.splice(index, 1);
    }
    currencies.push(currency);
    this.setState({ currencies: currencies });
  };

  handlePaginationChanged = (params) => {
    if (params && params.api) {
      this.setState({
        paginationState: {
          currentPage: params.api.paginationGetCurrentPage(),
          pageSize: params.api.paginationGetPageSize(),
        },
      });
    }
  };

  getFilteredData = () => {
    const {
      sortColumn,
      searchQuery,
      currencies: allCurrencies,
      activeOnly,
    } = this.state;

    let filtered = allCurrencies;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          (u.name != null &&
            u.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.symbol != null &&
            u.symbol.toLowerCase().includes(searchQuery.toLowerCase()))
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, activeOnly, isLoading, paginationState } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: currencies } = this.getFilteredData();

    const newCurrency = {
      currencyId: uuid(),
      name: t("NewCurrency"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() => this.handleCurrencySelected(newCurrency, true)}
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddCurrency")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedCurrencies", { count: totalCount })}</p>
        <CurrenciesTable
          currencies={currencies}
          onSort={this.handleSort}
          onRowClick={this.handleCurrencySelected}
          onPaginationChanged={this.handlePaginationChanged}
          paginationState={paginationState}
        />
      </div>
    );
  }
}

export default withTranslation(["markets"])(Currencies);
